import BaseCard from 'components/Cards/BaseCard';
import BuilderSectionControls from './components/BuilderControls';
import BuilderRow from './components/BuilderRow';
import { getRowLabel } from './utils/builderForm.utils';

const sectionConfig = {
  conditions: {
    title: 'If',
    addRowLabel: 'Add Condition',
    addGroupLabel: 'Add OR Group',
    usesGroups: true,
  },
  actions: {
    title: 'Then',
    addRowLabel: 'Add Action',
    usesGroups: false,
  },
  until: {
    title: 'Until',
    addRowLabel: 'Add Until Condition',
    addGroupLabel: 'Add OR Group',
    usesGroups: true,
  },
};

const BuilderSection = ({
  section,
  items,
  readOnly,
  rowErrors,
  onRemoveItem,
  onUpdateItem,
  onAddRow,
  onAddGroup,
  onStartThen,
  onStartUntil,
  onDone,
  onCancel,
  isSubmitting,
  showDoneButton = false,
  showCancelButton = false,
  hidePrimaryRowLabel = false,
  hideCategorySelector = false,
  hideRemoveButton = false,
  addActionButtonText = 'AND',
  doneButtonText = 'Save Global Action',
  doneButtonVariant = 'dark',
  doneButtonClassName = '',
  doneButtonStyle = {},
}) => {
  const config = sectionConfig[section];
  const groups = config.usesGroups ? items : [items];
  const hasRows = groups.some((group) => group.length > 0);

  return (
    <BaseCard
      className="global-action-builder-section global-action-builder-chain rounded-3 flex-shrink-0 w-100"
      bodyClassName="global-action-builder-section d-flex flex-column gap-4 rounded-3"
    >
      <div className="d-flex flex-column gap-4">
        {hasRows ? (
          groups.map((group, groupIndex) => (
            <div
              key={`${section}-group-${groupIndex}`}
              className="global-action-builder-section d-flex flex-column gap-4 rounded-3"
            >
              {group.map((item, rowIndex) => (
                <BuilderRow
                  key={item.id}
                  section={section}
                  label={
                    hidePrimaryRowLabel && rowIndex === 0
                      ? ''
                      : getRowLabel(section, groupIndex, rowIndex)
                  }
                  item={item}
                  hideCategorySelector={hideCategorySelector}
                  hideRemoveButton={hideRemoveButton}
                  readOnly={readOnly}
                  onUpdate={(updates) => onUpdateItem(item.id, updates)}
                  onRemove={() => onRemoveItem(item.id)}
                  validationMessage={rowErrors[item.id]}
                />
              ))}
            </div>
          ))
        ) : (
          <div
            className="global-action-builder-empty global-action-builder-muted small rounded-3 p-3"
            style={{ minHeight: 96 }}
          >
            No rows added yet.
          </div>
        )}
        <BuilderSectionControls
          section={section}
          config={config}
          readOnly={readOnly}
          onAddRow={onAddRow}
          onAddGroup={onAddGroup}
          onStartThen={onStartThen}
          onStartUntil={onStartUntil}
          onDone={onDone}
          onCancel={onCancel}
          isSubmitting={isSubmitting}
          showDoneButton={showDoneButton}
          showCancelButton={showCancelButton}
          addActionButtonText={addActionButtonText}
          doneButtonText={doneButtonText}
          doneButtonVariant={doneButtonVariant}
          doneButtonClassName={doneButtonClassName}
          doneButtonStyle={doneButtonStyle}
        />
      </div>
    </BaseCard>
  );
};

export default BuilderSection;
